module.exports = __webpack_public_path__ + "img/transport.e74a8601.png";